export function transactionBodyFromFormValues(values) {
    return {
        occurredAt: values.occurredAt,
        accountId: values.accountId,
        categoryId: values.categoryId ?? '',
        amount: values.amount,
        description: values.description?.trim() ?? '',
    };
}
/** Corpo de transferência pareada. Usar quando `values.direction === 'transfer'`. */
export function transferBodyFromFormValues(values) {
    return {
        occurredAt: values.occurredAt,
        amount: values.amount,
        fromAccountId: values.accountId,
        toAccountId: values.toAccountId ?? '',
        description: values.description?.trim() || undefined,
    };
}
